import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { FRAGMENT_CONTENT_VALIDATION } from 'src/graphql/schema';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation UpdateVariationContentValidation($id: ID!) {
    updateVariationContentValidation(id: $id) {
      id
      contentSafety {
        ...ContentValidation
      }
    }
  }
  ${FRAGMENT_CONTENT_VALIDATION}
`;

export const updateVariationContentValidation = (id) => {
  const variables = { id };

  return executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  }).then(({ data }) => getSingleProp(data));
};
